import AsyncStorage from "@react-native-async-storage/async-storage";
import Constants from "expo-constants";
import { Platform } from "react-native";
import { SafeJSONObject } from "../constants/Utils";
import { IBuyer } from "../interfaces/buyer";
import { IDeviceToken } from "../interfaces/deviceToken";
import BaseService from "./BaseService";
import * as Notifications from "expo-notifications";
import Colors from "../constants/Colors";

class DeviceTokenService extends BaseService {
  constructor() {
    super("device_token");
  }

  fetchFcmToken(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let token;
        if (Platform.OS === "android") {
          if (Constants.isDevice) {
            const { status: existingStatus } =
              await Notifications.getPermissionsAsync();
            let finalStatus = existingStatus;
            if (existingStatus !== "granted") {
              const { status } = await Notifications.requestPermissionsAsync();
              finalStatus = status;
            }
            if (finalStatus !== "granted") {
              reject({ message: "An unexpected error occured!" });
              throw new Error(
                "Failed to get push token for push notification. Permission denied."
              );
            }
            token = (await Notifications.getDevicePushTokenAsync()).data;
          } else {
            reject({ message: "An unexpected error occured!" });
            throw new Error(
              "Use physical device to receive Push Notifications."
            );
          }

          Notifications.setNotificationChannelAsync("default", {
            name: "default",
            importance: Notifications.AndroidImportance.MAX,
            vibrationPattern: [0, 250, 250, 250],
            lightColor: Colors.tintColor,
          });
        }
        if (Platform.OS === "web" && Constants?.deviceId) {
          token = `pwa-${Constants.deviceId}`;
        }

        await AsyncStorage.setItem("fcmToken", token);
        resolve(token);
      } catch (error) {
        reject({ message: "An unexpected error occured!" });
        throw error;
      }
    });
  }

  pushTokenToCloud() {
    return new Promise(async (resolve, reject) => {
      try {
        let dt: IDeviceToken;
        const fcm_token = (await this.fetchFcmToken()) || "";
        let buyer: IBuyer = SafeJSONObject(
          await AsyncStorage.getItem("buyerData")
        );

        dt = {
          token: fcm_token,
          status: "active",
          tag: buyer?._id || "",
          user_id: buyer?.user_id || "",
        };

        if (fcm_token && buyer?._id) {
          this.create(dt, { resetCache: false })
            .then((res) => {
              resolve(res);
            })
            .catch((error) => {
              reject({ message: "An unexpected error occurred!" });
              throw error;
            });
        } else {
          // Failed to register device. FCM token, user_session_token or buyer data not available.
          reject({ message: "An unexpected error occurred!" });
        }
      } catch (error) {
        reject({ message: "An unexpected error occurred!" });
        throw error;
      }
    });
  }
}

export default DeviceTokenService;
